module.exports = __webpack_public_path__ + "img/shopping-tools-tiles-cjdr.0fec7c86.png";